import { useEffect, useMemo, useRef, useState } from 'react';
import { logOut, openSideNav, registerRoutes } from '../../func';
import {
  Link,
  useHistory,
  useParams,
  useRouteMatch,
} from 'react-router-dom/cjs/react-router-dom.min';
import Axios from 'axios';
import EmlViewer from '../../utilities/emlViewer';

const ViewMail = () => {
  const { id } = useParams();
  const { path } = useRouteMatch();
  const history = useHistory();
  const ref = useRef({ abortController: new AbortController() });
  const authData = useMemo(() =>
    JSON.parse(window.localStorage.getItem('auth_data') || '')
  );

  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState();
  const [emlText, setEmlText] = useState('');

  const networkCalls = useMemo(
    () =>
      registerRoutes(
        {
          downloadEmail: {
            func: () => {
              setLoading(true);
              Axios.get('/api/v2/outbox/download/one/by/id', {
                params: {
                  ...authData,
                  outboundEmailId: id,
                },
                signal: ref.current.abortController.signal,
              })
                .then(result => {
                  const { email, buffer } = result.data;
                  setEmail(email);
                  const uint8Array = new Uint8Array(buffer.data);
                  const decoder = new TextDecoder('utf-8');
                  const str = decoder.decode(uint8Array);
                  setEmlText(str);
                })
                .catch(logOut)
                .finally(() => setLoading(false));
            },
            type: 'r',
          },
        },
        path
      ),
    [path]
  );

  useEffect(() => {
    networkCalls.downloadEmail();
    return () => {
      ref.current.abortController?.abort();
    };
  }, []);

  const goBack = event => {
    event?.preventDefault();
    history.goBack();
  };

  return (
    <div className="main">
      <div className="row">
        <div style={{ display: 'flex' }}>
          <Link to="/" onClick={openSideNav} style={{ marginRight: '12px' }}>
            <i className="material-icons black-text">menu</i>
          </Link>
          <Link to="/">Home</Link>
          <i className="material-icons">chevron_right</i>
          <a href="/" onClick={goBack}>
            Search Email
          </a>
          <i className="material-icons">chevron_right</i>
          <span className="grey-text">View Mail</span>
        </div>
      </div>
      <div className="row">
        <EmlViewer emlText={emlText} />
      </div>
    </div>
  );
};

export default ViewMail;
